import { type Theme, useTheme } from '@emotion/react';
import { useLingui } from '@lingui/react';
import CleaveOriginal from 'cleave.js/react.js';

import { hasString, normalizeReactNode } from '@twistopayments/design-system/utils';

import { typographyVariant } from '../typography';

import type { InputProps } from './input-common';
import * as styles from './input.styles';
// cleave.js types lag behind React 18 — cast to bypass JSX validation
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Cleave: any = CleaveOriginal as any;

type Props = Omit<InputProps, 'onChange'>;

export const StaticInput = ({
  border = true,
  value,
  placeholder,
  startAdornment,
  endAdornment,
  styles: stylesProp = {},
  formattedOptions,
}: Props) => {
  const theme = useTheme();

  const {
    i18n: { locale },
  } = useLingui();

  const rootStyles = (theme: Theme) => [
    styles.root(theme),
    !border && styles.borderLess,
    typographyVariant(theme).h3,
    stylesProp.root,
  ];

  const inputStyles = (theme: Theme) => [
    styles.input(theme),
    typographyVariant(theme).h3,
    stylesProp.input,
  ];

  const startAdornmentStyles = [styles.startAdornment(theme), stylesProp.startAdornment];

  const endAdornmentStyles = [styles.endAdornment(theme), stylesProp.endAdornment];

  return (
    <div css={rootStyles(theme)}>
      {normalizeReactNode(startAdornment, {
        css: startAdornmentStyles,
      })}
      {formattedOptions ? (
        <Cleave
          key={locale}
          readOnly
          css={inputStyles(theme)}
          options={formattedOptions}
          placeholder={placeholder}
          value={value}
        />
      ) : (
        <div css={[inputStyles(theme), { empty: !hasString(value) }]}>{value ?? placeholder}</div>
      )}
      {normalizeReactNode(endAdornment, {
        css: endAdornmentStyles,
      })}
    </div>
  );
};
